export enum ListTypes {
	'USERS' = 'USERS',
	'NPS' = 'NPS',
	'TUTORIAL_SCORE' = 'TUTORIAL_SCORE',
	'MOBILE' = 'LoginMobile',
	'REQUEST_DISCOUNT' = 'REQUEST_DISCOUNT',
	'RESERVATION_FORM' = 'RESERVATION_FORM'
}
